<template>
  <div>
    <div class="header" v-if="!activeServiceArea">PRICING</div>
    <div class="header pricing" v-else>
      <span class="color" v-bind:style="{backgroundColor: '#' + brand.color}"></span>
      <span class="name">{{ brand.name }}</span>
    </div>

    <transition name="fade" mode="out-in">
      <a :class="['logs-toggle', {on: !logs.show}]" @click="toggleLogsPanel" v-if="logs.current"><i :class="logsIcon"></i></a>
    </transition>

    <logs v-show="logs.current" ref="logs" />

    <div class="left-panel">
      <select v-model="selectedBrand" class="brands">
        <option v-for="(brand, i) in brands" :value="brand.id" :key="i">{{ brand.name }}</option>
      </select>

      <!-- Search Function -->
      <div class="data-field m-B-10">
        <div class="label">Search</div>
        <input type="text" class="input" v-model="searchInput" />
      </div>

      <div class="servicearea-list">
        <ul :class="{'disabled': loading}">
          <li @click="selectServiceArea(0)" :class="{'active': activeServiceArea === 0}">
            <i class="fas fa-globe"></i>
            <span>Global Pricing</span>
          </li>

          <li v-for="data in serviceArea" @click="selectServiceArea(data)" :key="data.id"
            :class="{'geofence-box': true, 'active': activeServiceArea === data.id}">
            <span class="color" v-bind:style="{backgroundColor: '#' + data.color}"></span>
            <span>{{ data.name }}</span>
          </li>
        </ul>

        <transition name="slide-down">
          <div class="loader" v-show="loading">
            <i class="fas fa-spinner fa-spin"></i> Loading
          </div>
        </transition>
      </div>
    </div>

    <div class="toggle-mobile">
      <ul class="tabs">
        <li :class="{'active': activeTab === 0, 'disabled': !isMobileClickable || isMTechPricing}" @click="mobileShowTab(0)">Services</li>
        <li :class="{'active': activeTab === 1, 'disabled': !isMobileClickable || isMTechPricing}" @click="mobileShowTab(1)"
          :title="!isMobileClickable ? 'Please enable at least 1 service type' : ''">Pricing - ASAP</li>
        <li :class="{'active': activeTab === 2, 'disabled': !isMobileClickable || isMTechPricing}" @click="mobileShowTab(2)"
          :title="!isMobileClickable ? 'Please enable at least 1 service type' : ''">Pricing - Future</li>
         <li :class="{'active': activeTab === 3, 'disabled': !isMobileClickable || isMTechPricing}" @click="mobileShowTab(3)"
        :title="!isMobileClickable ? 'Please enable at least 1 service type' : ''">Pricing - Charter</li>
         <li :class="{'active': activeTab === 4, 'disabled': !isMobileClickable || isMTechPricing}" @click="mobileShowTab(4)"
        :title="!isMobileClickable ? 'Please enable at least 1 service type' : ''">Pricing - Rental</li>
      </ul> 
    </div>

    <div :class="['right-panel', isMobileClickable ? 'open-panel' : '']">
      <div class="back" v-show="isMobile" @click="mobileShowTab(4)"><i class="fas fa-chevron-left"></i> Back</div>
      <ul class="tabs">
        <li :class="{'active': activeTab === 0, disabled: isMTechPricing}" @click="activeTab = 0">Services</li>
        <li :class="{'active': activeTab === 1, 'disabled': !isClickable || isMTechPricing}" @click="isClickable ? activeTab = 1 : ''"
          :title="!isClickable ? 'Please enable at least 1 service type' : ''">Pricing - ASAP</li>
        <li :class="{'active': activeTab === 2, 'disabled': !isClickable || isMTechPricing}" @click="isClickable ? activeTab = 2 : ''"
          :title="!isClickable ? 'Please enable at least 1 service type' : ''">Pricing - Future</li>
        <li :class="{'active': activeTab === 3, 'disabled': !isClickable || isMTechPricing}" @click="isClickable ? activeTab = 3 : ''"
          :title="!isClickable ? 'Please enable at least 1 service type' : ''">Pricing - Charter</li>
        <li :class="{'active': activeTab === 4, 'disabled': !isClickable || isMTechPricing}" @click="isClickable ? activeTab = 4 : ''"
          :title="!isClickable ? 'Please enable at least 1 service type' : ''">Pricing - Rental</li>
      </ul>

      <transition name="fade-right">
        <div v-if="transitionRightPanel && !isMTechPricing">
          <div v-show="activeTab === 0">
            <services @change="reRender" :isMobile="isMobile"></services>
          </div>
          <div v-show="activeTab === 1">
            <p class="global-notes" v-show="activeServiceArea === 0">
              Global Pricing updates all service areas for this brand, and saves only the fields whose values have changed.
            </p>
            <pricing-settings ref="asapPriceSettings" v-if="priceSettingsShow"
              @response="response" type="asap" :isMobile="isMobile"></pricing-settings>
          </div>
          <div v-show="activeTab === 2">
            <p class="global-notes" v-show="activeServiceArea === 0">
              Global Pricing updates all service areas for this brand, and saves only the fields whose values have changed.
            </p>
            <pricing-settings ref="priceSettings" v-if="priceSettingsShow"
              @response="response" type="future" :isMobile="isMobile"></pricing-settings>
          </div>
          <div v-show="activeTab === 3">
            <p class="global-notes" v-show="activeServiceArea === 0">
              Global Pricing updates all service areas for this brand, and saves only the fields whose values have changed.
            </p>
            <charter-pricing ref="charterSettings" v-if="priceSettingsShow" type="charter"
              @response="response" :isMobile="isMobile"></charter-pricing>
          </div>
          <div v-show="activeTab === 4">
            <p class="global-notes" v-show="activeServiceArea === 0">
              Global Pricing updates all service areas for this brand, and saves only the fields whose values have changed.
            </p>
            <rental ref="rental" v-if="priceSettingsShow" type="rental"
              @response="response" :isMobile="isMobile"></rental>
          </div>
        </div>
      </transition>

      <transition name="fade-right">
        <div v-if="isMTechPricing" class="is-mtech-label">
          Pricing Table and service settings is disabled for MTech enabled geofence.
        </div>
      </transition>
    </div>

    <transition name="slide-up">
      <div class="fixed-bottom-right"
        v-show="activeServiceArea !== '' && transitionRightPanel && !promoShow && !isServiceNonGlobal">
        <div class="row">
          <div class="column medium-6 medium-offset-3 end">
            <a :class="{'button cta small success':true, 'disabled':saving}" @click="save">
              <span v-if="saving"><i class="fas fa-spinner fa-spin"></i> Loading...</span>
              <span v-else>Save</span>
            </a>
          </div>
        </div>
      </div>
    </transition>

    <div :class="{'op--modal-container':true, 'hide':!global.modal}" @click="closeGlobalModal">
      <div class="op--modal">
        <div class="op--modal-content">

          <div class="global-modal-box" @click.stop v-if="global.status === ''">
            <p>Please select which service area you would like to apply your changes.</p>

            <label class="check-all">
              <input type="checkbox" @click="toggleSelectAll">
              Select all
            </label>
            <ul>
              <li v-for="data in completeServiceArea">
                <label>
                  <input type="checkbox" v-model="global.selectedServiceArea"
                    :value="data.id" />
                  <span>{{ data.name }}</span>
                </label>
              </li>
            </ul>
            <div class="global-error" v-if="!!global.message">{{global.message}}</div>
            <div class="row m-T-20">
              <div class="column medium-6 p-R-10">
                <a :class="{'button cta warning block': true, 'disabled': global.saving}"
                  @click="closeGlobalModal">Cancel</a>
              </div>
              <div class="column medium-6 p-L-10">
                <a :class="{'button cta success block': true, 'disabled': global.saving}" 
                  @click="updateGlobal">
                  <span v-if="global.saving"><i class="fas fa-spinner fa-spin"></i> Loading...</span>
                  <span v-else>Update</span>
                </a>
              </div>
            </div>
          </div>

          <div class="response-box" v-else>
            <i class="fas fa-check-circle fa-4x success"
              v-if="global.status === 'success'"></i>
            <i class="fas fa-times-circle fa-4x error" v-else></i>
            <span class="message">{{ global.message }}</span>
            <span class="extra" v-if="global.extra">{{ global.extra }}</span>
            <a class="button cta block" @click="closeGlobalModal">Close</a>
          </div>
       </div>
      </div>
    </div>

    <div :class="{'op--modal-container':true, 'hide': !responseModal.show}" @click="closeResponseModal">
      <div class="op--modal">
        <div class="op--modal-content" @click.stop>
          <div class="response-box">
            <i class="fas fa-check-circle fa-4x success"
              v-if="responseModal.status === 'success'"></i>
            <i class="fas fa-times-circle fa-4x error" v-else></i>
            <span class="message">{{ responseModal.message }}</span>
            <span class="extra" v-if="responseModal.extra">{{ responseModal.extra }}</span>
            <a class="button cta block" @click="closeResponseModal">Close</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
/* global CONFIG */
// import moment from 'moment'
import Services from './Services'
import Logs from './Logs'
import PricingSettings from './PricingSettings'
import CharterPricing from './CharterPricing'
import Rental from './Rental'
import ApiServiceArea from '@/modules/api/pricing/service-area'
import ApiBrands from '@/modules/api/brands'
import ApiServices from '@/modules/api/pricing/service-types'

export default {
  name: 'pricing',
  components: { Services, Logs, PricingSettings, CharterPricing, Rental },
  data () {
    return {
      searchInput: '',
      activeServiceArea: '',
      activeTab: 0,
      brandLoading: false,
      transitionRightPanel: false,
      global: {
        modal: false,
        selectedServiceArea: [],
        saving: false,
        status: '',
        message: '',
        extra: ''
      },
      responseModal: {
        show: false,
        status: '',
        message: '',
        extra: ''
      },
      priceSettingsShow: true,
      isMobileClickable: false,
      brand: {
        color: '',
        name: ''
      },
      isMobile: false,
      isMTechPricing: false
      // selectedBrand: this.$plugins.storage.getBrandInPricing() || CONFIG.default.brandId
    }
  },
  computed: {
    pricing () { return this.$store.state.pricing },
    isClickable () { return this.pricing.serviceTypes.isClickable },
    brands () { return this.$store.state.brands.list },
    selectedBrand: {
      get: function () { return this.$store.state.pricing.brandId },
      set: function (value) {
        this.transitionRightPanel = false
        this.activeServiceArea = ''
        this.$plugins.storage.setBrandInPricing(value)
        this.$store.commit('pricing/setBrandId', value)
        this.getServiceAreaList()
        this.getServiceTypes()
        this.$store.commit('pricing/setLogsData', {show: false})
      }
    },
    serviceArea () {
      let self = this
      return this.$store.state.pricing.serviceArea.list.filter(serviceArea => {
        let name = serviceArea.name.toLowerCase()
        return name.search(self.searchInput.toLowerCase()) > -1
      })
    },
    completeServiceArea () { return this.pricing.serviceArea.list },
    loading () { return this.pricing.serviceArea.isLoading },
    serviceTypeLoading () { return this.pricing.serviceTypes.isLoading },
    currentPage: {
      get: function () { return this.$store.state.pricing.serviceArea.currentPage },
      set: function (value) {
        this.$store.commit('pricing/setUserCurrentPage', parseInt(value))
        this.loadList()
      }
    },
    isLastPage () {
      let pricing = this.$store.state.pricing.serviceArea
      return (pricing.currentPage * pricing.perPage) >= pricing.maxList
    },
    totalPage () {
      let pricing = this.$store.state.pricing.serviceArea
      return Math.ceil(pricing.maxList / pricing.perPage)
    },
    promoShow () { return this.pricing.promo.show },
    saving () { return this.pricing.saving },
    _selectedServiceArea () { return this.pricing.serviceArea.activeId },
    isServiceNonGlobal () { return this._selectedServiceArea !== 0 && this.activeTab === 0},
    logs () { return this.pricing.logs },
    logsIcon () { return !this.logs.show ? 'fa fa-clipboard-list fa-2x' : 'fas fa-times fa-2x' }
  },
  methods: {
    // getBrand (e) {
      // let id = e.target.value
      // this.transitionRightPanel = false
      // this.activeServiceArea = ''
      // this.$plugins.storage.setBrandInPricing(id)
      // this.$store.commit('pricing/setBrandId', id)
      // this.getServiceAreaList()
      // this.getServiceTypes()
    // },
    mobileShowTab(tab) {
      if(this.activeTab === tab || tab == 4) {
        this.isMobileClickable = false
        this.activeServiceArea = ''
        this.$store.commit('pricing/setServiceAreaActiveId', '')
        this.transitionRightPanel = false
      }
      this.activeTab = tab
    },
    getBrandsList () {
      let self = this
      if (self.$store.state.brands.list.length) {
        self.getServiceAreaList()
        return
      }

      self.brandLoading = true
      ApiBrands.getBrands(self, function (res) {
        self.brandLoading = false
        self.getServiceAreaList()
      })
    },
    getServiceAreaList () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('pricing/setServiceAreaIsLoading', true)
      self.$store.commit('pricing/clearServiceAreaList')
      ApiServiceArea.getList(self, res => {
        self.$store.commit('pricing/setServiceAreaIsLoading', false)
        self.getServiceTypes()
      })
    },
    getServiceTypes () {
      let self = this
      if (self.serviceTypeLoading) { return }

      self.$store.commit('pricing/setServiceTypesIsloading', true)
      ApiServices.getAllService(self, r => {
        self.$store.commit('pricing/setServiceTypesIsloading', false)
      })
    },
    prev () {
      if (this.currentPage === 1) { return }
      this.$store.commit('pricing/setServiceAreaCurrentPage', this.$store.state.pricing.serviceArea.currentPage - 1)
      this.getServiceAreaList()
    },
    next () {
      if (this.isLastPage) { return }
      this.$store.commit('pricing/setServiceAreaCurrentPage', this.$store.state.pricing.serviceArea.currentPage + 1)
      this.getServiceAreaList()
    },
    selectServiceArea (id) {
      let self = this
      self.brand.name = id.name
      self.brand.color = id.color
      if (id != 0) id = id.id
      self.isMobileClickable = true
      self.activeServiceArea = id
      self.transitionRightPanel = false
      self.$store.commit('pricing/setServiceAreaActiveId', id)
      
      self.isMTechPricing = false
      self.$store.commit('pricing/setLogsData', {current: id})
      if (id === 0) {
        ApiServiceArea.setGlobalData(self, res => {
          let tmpPickupTypes = []
          let pickupTypes = this.$store.state.pricing.serviceTypes.list.filter(x => x.brandId === this.selectedBrand && !x.isCharter && x.brandEnabled)
          if (pickupTypes) {
            pickupTypes.forEach(pt => {
              tmpPickupTypes.push({
                id: pt.id,
                name: pt.code,
                pickupTypes: pt.pickupTypes
              })
            })
          }
          
          let tmpPickupTypesCharter = []
          let pickupTypesCharter = this.$store.state.pricing.serviceTypes.list.filter(x => x.brandId === this.selectedBrand && x.isCharter && x.brandEnabled)
          if (pickupTypesCharter) {
            pickupTypesCharter.forEach(pt => {
              tmpPickupTypesCharter.push({
                id: pt.id,
                name: pt.code,
                pickupTypes: pt.pickupTypes
              })
            })
          }
          
          self.$store.commit('pricing/setGlobalData', {
            pickupTypes: tmpPickupTypes,
            pickupTypesCharter: tmpPickupTypesCharter
          })
          
          self.$nextTick().then(() => {
            self.transitionRightPanel = true
            // self.activeTab = 1
            self.$forceUpdate()
          })
        })
      } else {
        self.activeTab = 0
        let serviceArea = self.$store.state.pricing.serviceArea.list.find(x => x.id == id)
        if (serviceArea.isMTechPricing) {
          self.isMTechPricing = true
          self.transitionRightPanel = false
          return
        }
        ApiServiceArea.getServiceAreaData(self, id, res => {
          let origData = []
          res.list.forEach(service => {
            origData.push({
              id: service.serviceType.id,
              enabled: self.cleanCopy(service.enabled),
              asap: self.cleanCopy(service.asap),
              charter: self.cleanCopy(service.charter),
              flight: self.cleanCopy(service.flight),
              future: self.cleanCopy(service.future),
              pickupTypes: self.cleanCopy(service.pickupTypes),
              rental: self.cleanCopy(service.rental)
            })
          })
          self.$store.commit('pricing/setOriginalData', origData)
          self.transitionRightPanel = true
        })
      }
    },
    cleanCopy (x) {
      return JSON.parse(JSON.stringify(x))
    },
    save () {
      if (this.saving) { return }

      if (this.activeServiceArea === 0) {
        this.global.modal = true
        return
      }

      if (this.activeTab === 1) {
        if (this.$refs.asapPriceSettings.save()) {
          this.$refs.asapPriceSettings.save()
        }
      }

      if (this.activeTab === 2) {
        if (this.$refs.priceSettings.save()) {
          this.$refs.priceSettings.save()
        }
      }

      if (this.activeTab === 3) {
        if (this.$refs.charterSettings.save()) {
          this.$refs.priceSettings.save()
        }
      }

      if (this.activeTab === 4) {
        if (this.$refs.rental.save()) {
          this.$refs.rental.save()
        }
      }
    },
    response (data) { this.responseModal = data },
    closeResponseModal () {
      let self = this
      this.responseModal.show = false
      setTimeout(() => {
        this.responseModal = {
          show: false,
          status: '',
          message: '',
          extra: ''
        }
      }, 500)
    },
    updateGlobal () {
      let self = this
      if (self.global.saving) { return }

      self.global.message = ''
      if (this.global.selectedServiceArea.length < 1) {
        self.global.message = 'Please select which service area you would like to apply your changes.'
        return
      }

      self.global.saving = true
      if (self.activeTab === 0) {
        ApiServices.setGlobalServiceEnable(self, this.global.selectedServiceArea, res => {
          self.global.saving = false
          if (res.error) {
            self.global.status = 'error'
            self.global.message = 'Oops! Something went wrong...'
            self.global.extra = res.error.message
            return
          }

          self.global.status = 'success'
          self.global.message = 'Successfully updated service area(s)!'
          self.$store.commit('pricing/resetEnableList')
        })
      } else {
        let data = {
          type: self.activeTab === 1 ? 'asap' : 'future',
          serviceArea: self.global.selectedServiceArea
        }
        if (self.activeTab === 3) data.type = 'charter'
        if (self.activeTab === 4) data.type = 'rental'
        
        ApiServices.setGlobalPriceSettings(self, data, res => {
          self.global.saving = false
          if (res.error) {
            self.global.status = 'error'
            self.global.message = 'Oops! Something went wrong...'
            self.global.extra = res.error.message
            return
          }

          self.global.status = 'success'
          self.global.message = 'Successfully updated service area(s)!'
        })
      }
    },
    closeGlobalModal () {
      if (this.global.saving) { return }
      this.global.status = ''
      this.global.message = ''
      this.global.extra = ''
      this.global.modal = false
    },
    toggleSelectAll () {
      if (this.global.selectedServiceArea.length !== this.completeServiceArea.length) {
        let tempId = []
        this.completeServiceArea.forEach(serviceArea => {
          tempId.push(serviceArea.id)
        })
        this.global.selectedServiceArea = tempId
      } else {
        this.global.selectedServiceArea = []
      }
    },
    reRender () {
      let self = this
      self.priceSettingsShow = false
      self.$nextTick().then(() => {
        self.priceSettingsShow = true
      })
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    },
    toggleLogsPanel () {
      this.$store.commit('pricing/setLogsData', {show: !this.logs.show})
      if (this.logs.show) {
        if (this.$refs.logs) this.$refs.logs.getLogs()
      }
    }
  },
  watch: {
    'logs.current': function (val) {
      if (!val) this.$store.commit('pricing/setLogsData', {show: false})
    }
    // _selectedServiceArea: function (val) {
    //   if (val === 0) { this.activeTab = 1 }
    // }
  },
  mounted () {
    if (!this.selectedBrand) {
      let brandId = this.$plugins.storage.getBrandInPricing() || CONFIG.default.brandId
      this.$store.commit('pricing/setBrandId', parseInt(brandId))
    }
    this.getBrandsList()
    this.setScreenSize()
  }
}
</script>

<style lang="scss" scoped>
$left-panel-width: 380px;
$toggle-size: 50px;

.m-B-10{ margin-bottom: 10px; }
.p-L-10{ padding-left: 10px; }
.p-R-10{ padding-right: 10px; }

.tooltip {
  background-color: red !important;
}

.header{
  height: 50px;
  font-weight: 700;
  font-size: 22px;
  color: #3F2975;
  background-color: #fff;
  display: block;
  line-height: 50px;
  padding-left: 70px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}

.logs-toggle {
  position: fixed;
  right: 0;
  top: 0;
  z-index: 3;
  width: $toggle-size;
  height: $toggle-size;
  line-height: $toggle-size;
  text-align: center;
  color: #777;
  transition: all 250ms;
  border-radius: 0;
  background-color: #F25E0D;
  color: #fff;
  border-bottom-left-radius: 3px;
  box-shadow: -2px 0 8px rgba(0,0,0,0.35);
  cursor: pointer;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
  -webkit-transition: .5s ease;
  -moz-transition: .5s ease;
  -o-transition: .5s ease;
  transition: .5s ease;

  & i { line-height: inherit; }

  &.on{
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease;
    -moz-transition: .5s ease;
    -o-transition: .5s ease;
    transition: .5s ease;
  }

}

.left-panel{
  width: $left-panel-width;
  height: calc(100% - 50px);
  background: #e8f0fb;
  position: fixed;
  top: 50px;
  left: 0;
  padding: 10px;
  overflow: auto;

  .brands{
    margin-bottom: 30px;
    border: 1px solid #ddd;
    padding: 10px;
    color: #333;
    height: 45px;
    position: relative;
    font-size:14px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('/assets/img/dropdown-arrow.png');
    background-repeat: no-repeat;
    background-position: right 50%;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background-color: #eee; }
  }
  .servicearea-list{
    position: relative;
    min-height: 50px;

    .loader{
      position: absolute;
      width: 80%;
      background: #fff;
      top: 50%;
      left: 10%;
      padding: 10px;
      text-align: center;
      font-size: 14px;
      font-style: italic;
      color: #777;
      margin-top: -25px;
      box-shadow: 0 0 4px rgba(0,0,0, .2);
      border-radius: 4px;

      i{
        color: #0D79F2;
        margin-right: 4px;
      }
    }
  }
  ul{
    list-style: none;
    padding: 0;
    margin: 6px 0;
    border: 1px solid #dedede;
    border-radius: 2px;
    overflow: hidden;
    box-shadow: 1px 1px 3px rgba(0,0,0, .1);

    &.disabled{ opacity: .3; }
    li{
      background: #fff;
      padding: 10px;
      font-size: 13px;
      border-bottom: 1px solid #dedede;
      font-weight: 600;
      cursor: pointer;

      &:last-child{ border-bottom: none; }
      &:hover{ background: #fafafa; }
      &.active{
        background: #f0f9ff;
        box-shadow: 0 0 0 3px #2f8cc7 inset;
      }
      i {
        margin-right: 5px;
        color: #acb6c3;
      }
      .color{
        display: inline-block;
        width: 10px;
        height: 10px;
        border: 1px solid #777;
        margin-right: 5px;
      }
    }
  }
}

.fixed-bottom-left{
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;
  background: #e8f0fb;
  padding: 10px;
  height: 50px;
  width: $left-panel-width;
  display: flex;

  .prev-next{
    background: #fafafa;
    height: 30px;
    width: 30px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    border: 1px solid #bbb;
    border-radius: 3px;
    cursor: pointer;

    &.disabled{
      opacity: .4;
      cursor: default;
    }
  }
  select{
    margin: 0 5px;
    border: 1px solid #ddd;
    padding: 5px 10px;
    color: #333;
    height: 30px;
    position: relative;
    font-size:14px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('/assets/img/dropdown-arrow.png');
    background-repeat: no-repeat;
    background-position: right 50%;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background-color: #eee; }
  }
}

.data-field{
  padding: 0;
  position: relative;

  &.no-label{ padding-top: 24px; }
  input[type='checkbox']{
    width: inherit;
    display: inline-block;
    margin: 0 3px 0 0;
  }
  .label{
    color: #0D79F2;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 130%;

    &.bigger{ font-size: 14px; }
    input[type='checkbox']{ vertical-align: -2px; }
  }
  .input{
    margin: 3px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
  }
}

.right-panel{
  width: calc(100% - (#{$left-panel-width}));
  height: calc(100% - 50px);
  position: fixed;
  top: 50px;
  left: $left-panel-width;
  background: #f4f9ff;
  padding: 70px 20px 50px;
  overflow: auto;

  .tabs{
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 50px;
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px 10px 0;
    border-bottom: 1px solid #b0c6e4;

    li{
      display: inline-block;
      height: 40px;
      line-height: 40px;
      border: 1px solid #b0c6e4;
      padding: 0 15px;
      margin-right: 5px;
      cursor: pointer;

      &.active{
        background: #f4f9ff;
        border-bottom: 1px solid #f4f9ff;
      }

      &.disabled{
        opacity: .4;
        background-color: #ddd;
        cursor: not-allowed;
      }
    }
  }
  .box{
    background: #fff;
    border-radius: 2px;
    border: 1px solid #b0c6e4;
    padding: 15px;
    box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);
  }
}

.global-notes{
  font-size: 14px;
  color: #333;
  font-style: italic;
  font-weight: 600;
}

.is-mtech-label{
  padding: 10px 0;
  font-size: 18px;
  font-family: 'Work Sans';
  font-weight: 600;
  font-style: italic;
  color: #777;
}

.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content{
  display: table-cell;
  vertical-align: middle;
  text-align: center;

  .response-box{
    text-align: center;
    margin-bottom: 40px;
    background-color: #fff;
    border-radius: 4px;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    position: relative;
    padding: 20px;

    .success{ color: #26D97A; }
    .error{ color: #F20D0D; }
    .message{
      display: block;
      margin-top: 10px;
      font-size: 15px;
      font-weight: 600;
    }
    .extra{
      border: 1px solid #f20d0d;
      background: #ffefef;
      border-radius: 4px;
      color: #000;
      padding: 5px;
      font-style: italic;
      font-size: 13px;
      display: block;
      margin-top: 10px;
    }
    .button { margin-top: 25px; }
  }
}
.global-modal-box{
  background-color: #fff;
  width: 400px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  position: relative;
  padding: 20px;
  border-radius: 2px;
  font-size: 14px;
  color: #444;

  .check-all{
    text-align: left;
    display: block;
    margin: 0 10px;
    padding: 0 5px;
    font-size: 13px;
    cursor: pointer;

    input {
      display: inline-block;
      width: inherit;
      vertical-align: -2px;
      margin: 0 5px 0 0;
    }
  }
  ul{
    list-style: none;
    text-align: left;
    margin: 5px 10px 15px;
    padding: 0;
    border: 1px solid #ccc;
    max-height: 300px;
    overflow: auto;

    li{
      border-bottom: 1px solid #eee;

      &:last-child{ border-bottom: none; }
      &:nth-child(odd){ background: #fafafa; }
      &:hover{ background: #eaeaea; }
      label{
        padding: 5px;
        display: block;
        cursor: pointer;
      }
    }
    input{
      display: inline-block;
      width: inherit;
      margin: 0 5px 0 0;
    }
  }
  .global-error{
    font-size: 13px;
    background: #ffeaea;
    padding: 5px;
    color: #f25757;
    border: 1px solid #f25757;
    line-height: 1.25;
    margin: 0 10px 15px;
  }
}

.fixed-bottom-right{
    height: 50px;
    width: calc(100% - (#{$left-panel-width}));
    left: $left-panel-width;
    bottom: 0;
    position: fixed;
    background: #fff;
    border-top: 1px solid #b0c6e4;
    text-align: center;
    padding: 5px 0;
    box-shadow: 0 -2px 3px rgba(0,0,0, .1);
    z-index: 3;

    .button{
      text-transform: uppercase;
      margin: 0 5px;
      min-width: 160px;
      i{ margin-right: 7px; }
    }
  }

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.fade-right-enter-active, .fade-right-leave-active { transition: all .15s ease; }
.fade-right-enter, .fade-right-leave-to {
  transform: translateX(15px);
  opacity: 0;
}

.toggle-mobile {
  display: none;
}

@media only screen and (max-width: 430px) {
  .pricing {
    font-size: 16px;
    font-size: 3.6vw;
    display: flex;
    align-items: center;

    .color {
      display: inline-block;
      width: 12px;
      height: 12px;
      border: 1px solid #777;
      margin-right: 5px;
    }

    .name {
      display: flex;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

  }
  
  .left-panel {
    width: 100%;
    padding: 20px;
    padding-bottom: 70px;
    .brands {
      margin-bottom: 15px;
    }
  }

  .right-panel {
    width: 100%;
    padding: 0;
    height: 0;

    &.open-panel {
      position: sticky;
      padding: 0 10px 120px;
      height: 100vh;

      .back {
        padding: 15px 0;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: 900;
        color: #777;
      }
    }

    .tabs {
      display: none;
    }
  }

  .toggle-mobile {
    display: block;
    cursor: pointer;
    position: fixed;
    bottom: 40px;
    left: 0;
    width: 100%;
    padding: 8px 0;
    height: 50px;
    -webkit-transition: top .25s;
    transition: top .25s;
    z-index: 9;
    text-transform: uppercase;
    font-weight: 900;

    .tabs{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      list-style: none;
      margin: 0;
      padding: 0;
      width: 100%;
      height: 90px;
      background: #fff;
      position: absolute;
      top: 0;
      left: 0;
      border: 1px solid #b0c6e4;
      font-size: 12px;
      display: flex;
      justify-content: space-between;

      li{
        display: flex;
        justify-content: left;
        align-items: center;
        border-right: 1px solid #b0c6e4;
        border-bottom: 1px solid #b0c6e4;
        padding: 0 20px;
        cursor: pointer;
        width: 50%;
        height: 30px;

        &.active{
          background: #cce1f9;
        }

        &.disabled{
          opacity: .4;
          background-color: #ddd;
          cursor: not-allowed;
        }
      }
    }
  }

  .fixed-bottom-right{
    left: 0;
    width: 100%;
    bottom: 90px;
    height: auto;
    padding: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pricing/index.vue